<template>
  <div>
    <div v-if="hasPrescriptions" class="dosage-tab-div">
      <!-- Month by Month Dosage Information -->
      <div v-for="monthData in prescriptionProgression" :key="monthData.month" class="dosage-month-div">
        <div class="div-block-2109">
          <div class="text-block-1256">Month {{ monthData.month }}</div>
          <div class="month-dosage"><span class="text-span-275">{{ monthData.cleanName }}</span></div>
          <div class="prescription-name"></div>
        </div>
        <div class="dosage-flex-div">
          <div class="div-block-1986">
            <div class="text-block-1258">Supply List:</div>
            <ul role="list" class="list-5">
              <li class="list-item-10">
                <div class="text-block-1259"><span class="supply-list-span">Alcohole wipes</span></div>
              </li>
              <li class="list-item-10">
                <div class="text-block-1259"><span class="supply-list-span">1</span> Vial of {{ monthData.cleanName }}</div>
              </li>

            
            </ul>
          </div>
          <div class="dosage-steps-div">
            <div class="dosage-step-1-2-div">
              <div class="dosage-step-div">
                <div class="step-header"><span class="text-span-275">Step 1:</span> Weekly Injection</div>
                <p class="paragraph-161">{{ monthData.directions }}</p>
                <img loading="lazy" src="@/assets/images/image_Syringe.svg" alt="" class="image-567">
                
              </div>
              
            </div>
            <div class="dosage-step-3-div">
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>No prescription found</p>
      <div style="height:380px"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      appMainWeb: process.env.VUE_APP_HOMEPAGE,
      provider: 1, // Set default provider or get it from props/store
      activeOrderIndex: 0 // Track which order's prescription is currently displayed
    };
  },

  computed: {
    ...mapGetters(['getLatestPrescription', 'getOrdersWithPrescriptions']),
    
    // Get orders that have prescriptions
    ordersWithPrescriptions() {
      return this.getOrdersWithPrescriptions;
    },
    
    // Check if any orders have prescriptions
    hasPrescriptions() {
      return this.ordersWithPrescriptions.length > 0;
    },
    
    // Get the currently active order
    activeOrder() {
      if (this.ordersWithPrescriptions.length === 0) return null;
      return this.ordersWithPrescriptions[this.activeOrderIndex];
    },
    
    // Get prescriptions for the active order only
    currentPrescriptions() {
      if (!this.activeOrder || !this.activeOrder.prescription_data) return [];
      return this.activeOrder.prescription_data;
    },
    
    medicationMappings() {
      const semaglutideMap ={
          '908c5ba0-b32d-4428-a9b3-5b40686ce5c7': { sku: 'sema25', strength: 0.25 },
          'c79860d9-0a53-461b-8301-c41c5689218a': { sku: 'sema25', strength: 0.25 },
          '90ee2eb4-04fc-4606-b4e1-aa99e9dcd486': { sku: 'sema25', strength: 0.25 },

          'd41b4087-9c9f-47c1-ba75-0d80da43eea4': { sku: 'sema5', strength: 0.5 },
          '94181388-bc6d-431d-be36-14c91e8cc205': { sku: 'sema5', strength: 0.5 },
          'bf788b23-98b1-41c9-a2f6-2d60346ebf26': { sku: 'sema5', strength: 0.5 },

          'feefda19-9a54-412f-9922-1fd1fab7e7ab': { sku: 'sema1', strength: 1 },
          'dc910579-dfc5-4337-aefe-e7be8e3f7021': { sku: 'sema1', strength: 1 },
          '9c9e0fc0-517e-4d1f-af7b-80d3768e1c44': { sku: 'sema1', strength: 1 },

          '5a75b266-e686-43ea-b14e-709307e714dc': { sku: 'sema175', strength: 1.75 },
          '04f72c96-ce83-4d93-9a28-9d79c3387a80': { sku: 'sema175', strength: 1.75 },
          'bd9b8db8-54d1-4f19-bf8d-e61d55528bd5': { sku: 'sema175', strength: 1.75 },

          'fc92790d-b74c-475a-97fa-c9a14f128d5f': { sku: 'sema250', strength: 2.5 },
          '3348a017-0f3f-423d-bc3b-7b4fce55b8c4': { sku: 'sema250', strength: 2.5 },
          '545116aa-413e-440d-9c24-b54339a91cb7': { sku: 'sema250', strength: 2.5 }
        };
      
      const tirzepatideMap = {
          '6c776624-f275-4142-827f-b4c43d49183b': { sku: 'tirz25', strength: 2.5 },
          'a4d39bc6-13ca-4a6c-a7a2-327119bf6749': { sku: 'tirz25', strength: 2.5 },
          '9bf720eb-787a-40f2-a89c-8020e51d0c71': { sku: 'tirz25', strength: 2.5 },

          'a59eef4c-a2d9-4fe3-9b0f-a7464d31b371': { sku: 'tirz5', strength: 5 },
          '04571369-e811-4a56-931c-030e2753d46b': { sku: 'tirz5', strength: 5 },
          'c887a956-5fc9-44a4-bf1e-de5e4470938c': { sku: 'tirz5', strength: 5 },

          'c01bffe2-4796-448d-bcb3-039bf62f9329': { sku: 'tirz75', strength: 7.5 },
          'fee47de1-9f6e-4932-84ed-2e0cc87f97d1': { sku: 'tirz75', strength: 7.5 },
          'c6f8f91b-9e84-4454-b72e-c7b1c969235b': { sku: 'tirz75', strength: 7.5 },

          'c1e02747-5aec-4930-8f04-a92d67a50b41': { sku: 'tirz10', strength: 10 },
          '6a031f5e-9f44-4ae2-9d19-4f884101ae0c': { sku: 'tirz10', strength: 10 },
          'dbb062ed-7765-43ce-b621-dbbfffbf9c56': { sku: 'tirz10', strength: 10 },

          '65736f9b-e903-4387-9635-748975dcb908': { sku: 'tirz125', strength: 12.5 },
          '96b93e96-409c-41a2-876f-da723ef17ce8': { sku: 'tirz125', strength: 12.5 },
          '194a2a58-33dc-4082-8158-5ff83b324115': { sku: 'tirz125', strength: 12.5 },

          '93e82881-b162-405a-84b6-199c10b5cccc': { sku: 'tirz15', strength: 15 },
          '15313d85-c67f-40d0-af28-86f9707b61ec': { sku: 'tirz15', strength: 15 },
          'afaa7f41-4b53-4c99-8858-0a278d11991a': { sku: 'tirz15', strength: 15 }
        };

      return {
        Semaglutide: semaglutideMap,
        Tirzepatide: tirzepatideMap
      };
    },

    // List of medication IDs to exclude (B12 and Ondansetron)
    excludedMedications() {
      return [
        "d32725de-a0b3-46e4-b815-8f45b9dc57c5"
      ];
    },

    medicationType() {
      if (!this.currentPrescriptions || this.currentPrescriptions.length === 0) return '';
      
      // Filter out B12 and Ondansetron from consideration
      const filteredMeds = this.currentPrescriptions.filter(med => {
        if (!med) return false;
        // Allow medications with empty medId if they have a name
        if (!med.medId || med.medId === '') {
          return med.name && !this.isExcludedMedication(med);
        }
        return !this.excludedMedications.includes(med.medId) && !this.isExcludedMedication(med);
      });
      
      if (!filteredMeds || filteredMeds.length === 0) return '';
      
      const firstMed = filteredMeds.find(med => {
        if (!med || !med.name) return false;
        
        const nameLower = med.name.toLowerCase();
        // Check if medication type is in name or if we can find it by medId
        return nameLower.includes('tirzepatide') || 
               nameLower.includes('semaglutide') ||
               (med.medId && (
                 (this.medicationMappings.Tirzepatide && this.medicationMappings.Tirzepatide[med.medId]) || 
                 (this.medicationMappings.Semaglutide && this.medicationMappings.Semaglutide[med.medId])
               ));
      });

      if (!firstMed) return '';
      
      // First check medId in mappings
      if (firstMed.medId) {
        if (this.medicationMappings.Tirzepatide && this.medicationMappings.Tirzepatide[firstMed.medId]) return 'Tirzepatide';
        if (this.medicationMappings.Semaglutide && this.medicationMappings.Semaglutide[firstMed.medId]) return 'Semaglutide';
      }
      
      // Fallback to checking name
      if (firstMed.name) {
        return firstMed.name.toLowerCase().includes('tirzepatide') ? 'Tirzepatide' : 'Semaglutide';
      }
      
      return '';
    },

    filteredPrescriptions() {
      if (!this.currentPrescriptions || this.currentPrescriptions.length === 0) return [];

      // Filter out B12 and Ondansetron
      return this.currentPrescriptions.filter(med => {
        // Make sure med is defined and has required properties
        if (!med) {
          return false;
        }
        
        // Exclude by ID or name
        if ((med.medId && this.excludedMedications.includes(med.medId)) || this.isExcludedMedication(med)) {
          return false;
        }
        
        // Include only medications that match the determined type
        const medicationType = this.medicationType;
        if (!medicationType) return false;
        
        if (med.name) {
          const nameLower = med.name.toLowerCase();
          if (nameLower.includes(medicationType.toLowerCase())) {
            return true;
          }
        }
        
        // Check by medId in the corresponding medication mapping
        if (med.medId && 
            this.medicationMappings[medicationType] && 
            this.medicationMappings[medicationType][med.medId] !== undefined) {
          return true;
        }
        
        return false;
      });
    },

    sortedPrescriptions() {
      if (!this.filteredPrescriptions.length) return [];

      // Sort all prescriptions by strength (from lowest to highest)
      return [...this.filteredPrescriptions].sort((a, b) => {
        const strengthA = parseFloat(this.getDosageFromPrescription(a));
        const strengthB = parseFloat(this.getDosageFromPrescription(b));
        return strengthA - strengthB;
      });
    },

    prescriptionProgression() {
      if (!this.sortedPrescriptions.length) return [];

      // Get prescriptions with valid prefix numbers and sort by the prefix number
      const prescriptionsWithPrefix = this.sortedPrescriptions
        .map(prescription => ({
          prescription,
          prefixNumber: this.getMonthFromPrescriptionName(prescription.name)
        }))
        .filter(item => item.prefixNumber !== null)
        .sort((a, b) => a.prefixNumber - b.prefixNumber);

      // Take only the first 3 prescriptions and assign them as Month 1, 2, 3
      const result = [];
      for (let i = 0; i < Math.min(3, prescriptionsWithPrefix.length); i++) {
        const item = prescriptionsWithPrefix[i];
        
        result.push({
          month: i + 1, // Always show as Month 1, 2, 3 regardless of actual prefix number
          strength: this.getDosageFromPrescription(item.prescription),
          directions: item.prescription.directions,
          medicationType: this.medicationType,
          cleanName: this.cleanPrescriptionName(item.prescription.name),
          originalPrefix: item.prefixNumber // Keep track of original for debugging if needed
        });
      }
      
      return result;
    }
  },

  methods: {
    // Set which order's prescription is displayed
    setActiveOrder(index) {
      if (index >= 0 && index < this.ordersWithPrescriptions.length) {
        this.activeOrderIndex = index;
      }
    },
    
    // Get a display name for the order tab
    getOrderTabName(order, index) {
      // Try to determine medication type from the order
      let medType = '';
      if (order.prescription_data && order.prescription_data.length > 0) {
        const firstMed = order.prescription_data.find(med => {
          if (!med || !med.name) return false;
          const nameLower = med.name.toLowerCase();
          return nameLower.includes('tirzepatide') || nameLower.includes('semaglutide');
        });
        
        if (firstMed && firstMed.name) {
          medType = firstMed.name.toLowerCase().includes('tirzepatide') ? 'Tirzepatide' : 'Semaglutide';
        }
      }
      
      // Get date if available
      let dateStr = '';
      if (order.created_at) {
        const date = new Date(order.created_at);
        dateStr = date.toLocaleDateString();
      }
      
      // Construct tab name
      if (medType && dateStr) {
        return `${medType} (${dateStr})`;
      } else if (medType) {
        return medType;
      } else if (dateStr) {
        return `Order ${index + 1} (${dateStr})`;
      } else {
        return `Order ${index + 1}`;
      }
    },

    // Check if medication names indicate they should be excluded
    isExcludedMedication(medication) {
      // Check if medication or medication.name are undefined
      if (!medication || !medication.name) {
        return false;
      }
      
      const nameLower = medication.name.toLowerCase();
      return (
        nameLower.includes('b12') || 
        nameLower.includes('cyanocobalamin') || 
        nameLower.includes('ondansetron')
      );
    },

    // Clean prescription name by removing T1-T6 and S1-S5 prefixes
    cleanPrescriptionName(name) {
      if (!name) return '';
      
      // Remove T1-T6 or S1-S5 prefix before the first comma
      const commaIndex = name.indexOf(',');
      if (commaIndex > 0) {
        const prefix = name.substring(0, commaIndex).trim();
        // Check if prefix matches T1-T6 or S1-S5 pattern
        if (/^[TS][1-6]$/.test(prefix)) {
          return name.substring(commaIndex + 1).trim();
        }
      }
      
      return name;
    },

    // Extract month number from prescription name prefix (T1-T6, S1-S5)
    getMonthFromPrescriptionName(name) {
      if (!name) return null;
      
      const commaIndex = name.indexOf(',');
      if (commaIndex > 0) {
        const prefix = name.substring(0, commaIndex).trim();
        // Check if prefix matches T1-T6 or S1-S5 pattern
        const match = prefix.match(/^[TS]([1-6])$/);
        if (match) {
          const monthNum = parseInt(match[1]);
          // Validate range: T1-T6 and S1-S5
          if ((prefix.startsWith('T') && monthNum >= 1 && monthNum <= 6) ||
              (prefix.startsWith('S') && monthNum >= 1 && monthNum <= 5)) {
            return monthNum;
          }
        }
      }
      
      return null;
    },
    
    getDosageFromPrescription(prescription) {
      // Check if prescription is valid
      if (!prescription) {
        return '0';
      }
      
      // First try to get strength from medication mapping
      if (prescription.medId && this.medicationType) {
        const medicationMap = this.medicationMappings[this.medicationType];
        if (medicationMap && medicationMap[prescription.medId]) {
          return medicationMap[prescription.medId].strength;
        }
      }

      // If no mapping found, try to get dose from strength field
      if (prescription.strength && prescription.strength !== 'None') {
        const strengthMatch = prescription.strength.match(/(\d+\.?\d*)\s*mg/);
        if (strengthMatch) {
          return strengthMatch[1];
        }
      }

      // Then try to get from name if it contains mg
      if (prescription.name) {
        const nameMatch = prescription.name.match(/(\d+\.?\d*)\s*mg/);
        if (nameMatch) {
          return nameMatch[1];
        }
      }

      // Finally check directions
      if (prescription.directions) {
        return this.getDosageFromDirections(prescription.directions);
      }
      
      return '0';
    },

    getDosageFromDirections(directions) {
      // Safety check
      if (!directions || typeof directions !== 'string') {
        return '0';
      }
      
      // Try various patterns in directions
      const patterns = [
        /\((\d+\.?\d*)\s*mg(?:\s+dose)?\)/, // (7.5mg) or (7.5mg dose)
        /Inject\s+\d+\s+units\s+\((\d+\.?\d*)mg\)/i, // Inject 50 units (7.5mg)
        /(\d+\.?\d*)\s*mg/, // Simple mg mention
        /(\d+\.?\d*)\s*mg\/ml/ // mg/ml format
      ];

      for (const pattern of patterns) {
        const match = directions.match(pattern);
        if (match) {
          return match[1];
        }
      }
      
      return '0';
    },

    getImageUrl(medicationType, strength, isPoster = false) {
      try {
        strength = strength > 15 ? strength/2 : strength
        const baseUrl = 'https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/label_updated/';
        const suffix = isPoster ? '-p-500' : '';
        
        // Format the filename according to the actual pattern
        let formattedStrength = strength;
        // Handle special case for numbers less than 1 (e.g., 0.25 -> .25)
        if (parseFloat(strength) < 1) {
          formattedStrength = `.${(parseFloat(strength) * 100)}`;
        }
        
        const filename = `${medicationType}-${formattedStrength}mg${suffix}.jpg`;
        return `${baseUrl}${filename}`;
      } catch (e) {
        console.error('Error loading image:', e);
        return '';
      }
    }
  }
}
</script>

<style scoped>
.order-tabs-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px;
}

.order-tab {
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-family: var(--mulish);
  font-weight: 600;
  transition: all 0.2s ease;
}

.order-tab:hover {
  background-color: #f5f5f5;
}

.order-tab.active-tab {
  background-color: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.prescription-content {
  margin-top: 15px;
}

.prescription-name {
  font-size: 14px;
  color: #666;
  margin-top: 5px;
  font-weight: 500;
}
</style>